export class BusinessInteractEventDto {
    event: string;
    event_params: BusinessEventParamsDto;
    user_properties?: BusinessUserPropertiesDto;
}

export class BusinessUserPropertiesDto {
    pas_dni_hashed: string;
    birthday?: string;
    user_type: string;
}

export class BusinessEventParamsDto {
    evento_interactivo_categoria: string;
    evento_interactivo_accion: string;
    evento_interactivo_etiqueta: string;
    micrositio: string;            
    page_path: string;
    page_type: string;
    page_title: string;
    homemarket: string;
    environment: string;
    login: boolean;
}

export class BusinessInteractPaymentEventDto {
    event: string;
    event_params: BusinessInteractPaymentEventParamsDto;
}

export class BusinessInteractPaymentEventParamsDto {
    evento_interactivo_categoria: string;
    evento_interactivo_accion: string;
    evento_interactivo_etiqueta: string;
    app: boolean;
    environment: string;
    corp: boolean;
    page_path: string;
    page_type: string;
    negocio: string;
    micrositio: string;
    homemarket: string;
    buy_instance: string;
    login: boolean;
    currency: string;
    initial_date: string;
    end_date: string;
    from_iata: string;
    to_iata: string;
    trip_type: string;
    time: string;
    passengers_adult: number;
    passengers_child: number
    passengers_infant: number;
    passengers_pet: number;
    pax: number;
    full_trip: string;
}